/**
 * @generated SignedSource<<275dc094b2586e9c667521dd3eebd79e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueRow$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useCellsConditionalFormatting_rules">;
  readonly " $fragmentType": "IssueRow";
};
export type IssueRow$key = {
  readonly " $data"?: IssueRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "IssueRow",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "condition": "isConditionalFormattingEnabled",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "useCellsConditionalFormatting_rules"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "8bb10e5786d1690e677fdb7b7af7715c";

export default node;
